import store from '@/store'
import { MessageBox } from 'element-ui'
import MetaMaskOnboarding from '@metamask/onboarding'
import { evaluateMetaMaskAccess, maskAccountValue } from '@/utils/account-policy'

/**
 * res:0 Metamask account mismatch
 * res:1 Metamask account matching succeeded
 * res:-1 Metamask is not installed
 */
export function CheckAccount() {
  const userInfo = store.getters.userInfo
  const metaMaskObj = store.getters.metaMaskObj
  const result = evaluateMetaMaskAccess({
    initOk: metaMaskObj.initOk,
    isInstall: metaMaskObj.isInstall,
    userType: userInfo.type,
    userAccount: userInfo.account,
    metaAccount: metaMaskObj.account,
    foundationManager: metaMaskObj.FoundationManager,
    auditor: metaMaskObj.Auditor
  })

  if (result.res === '-1') {
    MessageBox.confirm(`You have not installed metamask. Please install it first. If it is already installed, please refresh your browser.`, 'Tips', {
      confirmButtonText: 'Install',
      showCancelButton: false,
      type: 'warning'
    }).then(() => {
      const onboarding = new MetaMaskOnboarding()
      onboarding.startOnboarding()
    }).catch(e => {})
    return result
  }

  if (result.res === '0') {
    const isRegisteredUser = Number(userInfo.type) === 0
    const message = isRegisteredUser
      ? `Please use your authenticated account: ${maskAccountValue(result.expectedAccount)}`
      : `Please use the account specified by the role to operate!(Account: ${maskAccountValue(result.expectedAccount)})`

    MessageBox.confirm(message, 'Tips', {
      confirmButtonText: 'Close',
      showCancelButton: false,
      type: 'warning'
    }).then(() => {}).catch(e => {})
  }

  return result
}
